import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { useDonationFormsStore } from '../store';


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingInfo',
  props: ["is_logged_in", "email", 'show_country', 'show_county', 'show_city', 'show_postal', 'show_tax', 'show_phone_no', 'show_company' , "enable_80g_code_field", "strings"],
  setup(__props, { expose: __expose }) {
  __expose();

const store = useDonationFormsStore();
const props = __props;
const countries = ref([]);
const select_loading = ref(false);
const country = ref('');

const lifeline_donation = globalThis.lifeline_donation;

const setValue = (key, val) => {  
  store[key] = val;
};
const setBillingValue = (key, val: Event) => {
  store.billing_fields[key] = (val.target as HTMLInputElement).value;
};
const trans = (key) => {
  if (props.strings) {
    return props.strings[key];
  }
};
const getCountries = () => {
  select_loading.value = true;

  const $ = jQuery;

  $.ajax({
    url: lifeline_donation.homeurl+ '/wp-json/webinane-commerce/v1/countries',
    success: res => {
      countries.value = res.countries
    },
    complete: res => {
      select_loading.value = false
    }
  })
};

onMounted(() => {
  if (props.is_logged_in && props.email) {
      store.billing_fields.email = props.email;
    }
    getCountries();
})



const __returned__ = { store, props, countries, select_loading, country, lifeline_donation, setValue, setBillingValue, trans, getCountries }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})